import { QueryClient } from '@tanstack/react-query';

import { ConsoleApiError } from '@/api/client';

/**
 * Retry once on transient failures (network, 5xx), never on 4xx: a client
 * error will not succeed on replay, and for expensive-search rejections
 * (400 `statement_timeout`) an automatic retry would silently double the
 * database cost of the failed query.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (error instanceof ConsoleApiError && error.status >= 400 && error.status < 500) {
    return false;
  }
  return failureCount < 1;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: shouldRetryQuery,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: 0 },
  },
});
